<template>
  <div class="d-flex-column justify-start align-start gap-18">
    <div class="d-flex-column justify-start align-start gap-0">
      <h5 class="t-white title-h5 font-family-1">
        {{ $t("new.unsaved_boosters") }}
      </h5>
      <p class="t-grey regular-l font-family-1">
        {{ $t("new.unsaved_boosters_desc") }}
      </p>
    </div>
    <div
      class="extra_option_picker d-flex-column justify-start align-start gap-9"
    >
      <div class="d-flex-row justify-start flex-wrap md-row-to-col">
        <button
          class="role_picker d-flex-row flex-3 gap-5 medium-l font-family-2 white-space-no trader_picker"
          style="min-width: 190px"
          v-for="option in traderOptions"
          :key="option"
          :class="[
            checkoutStore.getPackExtraOptions['trader'] === option.id &&
              'selected',
          ]"
          @click="selectTrader(option)"
        >
          {{ option.title }}
        </button>
      </div>
      <label class="medium-m font-family-2 t-grey caps">{{
        $t("new.armor_type")
      }}</label>
      <div class="d-flex-row justify-start md-row-to-col">
        <button
          v-for="option in armorOptions"
          class="role_picker d-flex-row flex-3 gap-5 medium-l font-family-2"
          style="padding: 6px 12px"
          @click="selectArmor(option.id)"
          :class="[
            checkoutStore.getPackExtraOptions['armorType'] === option.id &&
              'selected',
          ]"
        >
          {{ option.title }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {
    armorOptions() {
      if (this.getGamePack?.pack_extra_options) {
        return this.getGamePack?.pack_extra_options?.filter(
          (option) => option.description === "armor"
        );
      }
      return [];
    },

    traderOptions() {
      if (this.getGamePack?.pack_extra_options) {
        return this.getGamePack?.pack_extra_options?.filter(
          (option) => option.description === "traders"
        );
      }
      return [];
    },
  },
  methods: {
    selectArmor(optionId) {
      this.checkoutStore.setPackExtraOptions({
        armorType: parseInt(optionId),
      });
    },
    selectTrader(option) {
      if (this.checkoutStore.getPackExtraOptions["trader"] === option.id) {
        // this.$store.commit("removeExtraPackOptions", "trader");
        this.checkoutStore.removeExtraPackOptions("trader");
      } else {
        this.checkoutStore.setPackExtraOptions({
          trader: option.id,
        });
      }
    },
  },
  setup() {
    const { getGamePack } = useGameStore();
    const checkoutStore = useCheckoutStore();
    return {
      checkoutStore,
      getGamePack,
    };
  },
};
</script>
